module.exports = __webpack_public_path__ + "img/nc.0be0d068.png";